import React from 'react';
import {Spinner} from '..';
import {useTableSort} from '../../utils/sortUtilities';
import Table from '../Table';

const HEAD_CELLS = [
  {
    id: 'code',
    numeric: false,
    disabledPadding: true,
    label: 'Code',
  },
  {
    id: 'siteCode',
    numeric: false,
    disabledPadding: false,
    label: 'Site Code',
  },
  {
    id: 'siteNo',
    numeric: false,
    disabledPadding: false,
    label: 'Site No',
  },
  {
    id: 'elevator',
    numeric: false,
    disabledPadding: false,
    label: 'Elevator',
  },
  {
    id: 'status',
    numeric: false,
    disabledPadding: false,
    label: 'Status',
  },
  {
    id: 'dateOfExpiredFrom',
    numeric: false,
    disabledPadding: false,
    label: 'Valid From',
  },
  {
    id: 'dateOfExpiredTo',
    numeric: false,
    disabledPadding: false,
    label: 'Valid To',
  },
  {
    id: 'createdAt',
    numeric: false,
    disabledPadding: true,
    label: 'Created at',
  },
];

const DATA_CELLS = [
  'code',
  'siteCode',
  'siteNo',
  'elevator',
  'status',
  'dateOfExpiredFrom',
  'dateOfExpiredTo',
  'createdAt',
];

const CardsTable = ({cards, onAdd, onRowClick, rowHref, loading}) => {
  const tableOrder = useTableSort('asc', 'createdAt');

  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={cards}
      headCells={HEAD_CELLS}
      dataCells={DATA_CELLS}
      onAdd={onAdd}
      onRowClick={onRowClick}
      rowHref={rowHref}
      {...tableOrder}
    />
  );
};

export default CardsTable;
